import styled from "styled-components";
import { Colors } from "../../values/colors";

export const PageBody = styled.div`
  padding: 1.25rem 1.5rem;
`;

export const FiltersBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.5rem;
  gap: 16px;
  flex-wrap: wrap;
`;

export const YearTabsGroup = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`;

export const YearTab = styled.button`
  padding: 6px 18px;
  border-radius: 99px;
  border: 1px solid ${({ active }) => (active ? "transparent" : Colors.ultraLightGray)};
  background: ${({ active }) => (active ? Colors.primary : "transparent")};
  color: ${({ active }) => (active ? "#fff" : Colors.blueGray)};
  font-size: 14px;
  font-weight: ${({ active }) => (active ? 700 : 400)};
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: ${({ active }) => (active ? Colors.primary : Colors.ultraLightGray2)};
  }
`;

export const SearchWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid ${Colors.ultraLightGray};
  border-radius: 8px;
  padding: 8px 14px;
  min-width: 220px;
  background: ${Colors.white};

  &:focus-within {
    border-color: ${Colors.primary};
  }
`;

export const SearchInput = styled.input`
  border: none;
  outline: none;
  font-size: 14px;
  color: ${Colors.blueGray};
  width: 100%;
  background: transparent;

  &::placeholder {
    color: ${Colors.lightGray};
  }
`;

export const CardWrapper = styled.div`
  position: relative;
  z-index: ${({ $panelOpen }) => ($panelOpen ? 200 : "auto")};
`;

export const PanelBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 150;
  animation: panelFadeIn 0.2s ease-in-out;

  @keyframes panelFadeIn {
    from { opacity: 0; }
    to   { opacity: 1; }
  }
`;

export const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;

  @media (max-width: 1100px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 680px) {
    grid-template-columns: 1fr;
  }
`;

export const SurveyCard = styled.div`
  background: #fff;
  border: 1px solid ${({ $compareSelected }) => $compareSelected ? Colors.primaryPurple : Colors.ultraLightGray};
  border-radius: 10px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  box-shadow: ${({ $compareSelected }) => $compareSelected
    ? '0px 2px 8px rgba(93,61,237,0.15), 0 0 0 2px rgba(93,61,237,0.08)'
    : '0px 2px 8px rgba(0, 0, 0, 0.05)'};
  transition: border-color 0.15s, box-shadow 0.15s;
`;

export const CardTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const StatusBadge = styled.span`
  background: ${({ bg }) => bg};
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 14px;
  border-radius: 99px;
  white-space: nowrap;
`;

export const CardTitle = styled.h3`
  font-size: 15px;
  font-weight: 700;
  color: ${Colors.primaryColor};
  margin: 0;
  line-height: 1.4;
`;

export const StatsRow = styled.div`
  display: flex;
  align-items: stretch;
  gap: 0;
`;

export const StatBlock = styled.div`
  display: flex;
  flex-direction: column;
  background: ${Colors.ultraLightGray3};
  padding: 12px 16px;
  border-radius: 8px;
  gap: 6px;
  flex: 1;
`;

export const StatLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 13px;
  color: ${Colors.blueMist};
`;

export const StatValueRow = styled.div`
  display: flex;
  align-items: baseline;
  gap: 3px;
`;

export const StatValue = styled.span`
  font-size: 28px;
  font-weight: 700;
  color: ${Colors.primaryPurple};
  line-height: 1;
`;

export const StatUnit = styled.span`
  font-size: 12px;
  color: ${Colors.blueMist};
`;

export const StatDivider = styled.div`
  width: 1px;
  margin: 0 16px;
  align-self: stretch;
`;

export const CardDivider = styled.hr`
  border: none;
  margin: 0;
`;

export const CardBottom = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const DateRange = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: ${Colors.blueGray};
  background: ${Colors.ultraLightGray3};
  border-radius: 4px;
  padding: 6px 12px;
`;

export const ArrowBtn = styled.button`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: ${Colors.primaryPurple};
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.85;
  }
`;

export const MenuItem = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 10px 14px;
  border: none;
  background: transparent;
  text-align: left;
  font-size: 13px;
  font-weight: 500;
  color: ${({ variant }) =>
    variant === "danger" 
    ? Colors.red 
    : variant === "pause"
      ? Colors.secondaryPurple
      : Colors.blueGray
    };
  };
  cursor: pointer;

  &:hover {
    background: ${Colors.ultraLightGray2};
  }
`;

export const EmptyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 24px;
  gap: 12px;
  text-align: center;
`;

export const EmptyIconCircle = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: rgba(93, 61, 237, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 4px;
`;

export const EmptyTitle = styled.h3`
  font-size: 18px;
  font-weight: 700;
  color: ${Colors.primaryPurple};
  margin: 0;
`;

export const EmptySubtext = styled.p`
  font-size: 14px;
  color: ${Colors.blueMist};
  max-width: 380px;
  margin: 0;
  line-height: 1.6;
`;

export const BannerWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  background: ${Colors.ultraLightGray3};
  border: 1px solid ${({ $accentColor }) => $accentColor || Colors.primaryPurple};
  border-radius: 10px;
  padding: 14px 20px;
  margin-bottom: 20px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.05);
`;

export const BannerIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const BannerBody = styled.div`
  flex: 1;
  min-width: 0;
`;

export const BannerSubtext = styled.div`
  font-size: 13px;
  color: ${Colors.blueMist};
  margin-top: 2px;
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const BannerActionBtn = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  background: ${Colors.white};
  border-radius: 6px;
  padding: 7px 16px;
  font-size: 13px;
  font-weight: 600;
  color: ${Colors.primaryPurple};
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  transition: background 0.15s;

  &:hover {
    background: rgba(93, 61, 237, 0.08);
  }
`;

export const BannerCloseBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  cursor: pointer;
  color: ${Colors.lightGray};
  padding: 4px;
  border-radius: 4px;
  flex-shrink: 0;
  transition: all 0.15s;

  &:hover {
    color: ${Colors.blueGray};
    background: ${Colors.ultraLightGray2};
  }
`;

/* ── Comparison Bar ── */
export const ComparisonBarWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  background: ${Colors.primaryPurple};
  border-radius: 10px;
  padding: 10px 16px;
  margin-bottom: 16px;
`;

export const ComparisonBarLabel = styled.span`
  font-size: 13px;
  font-weight: 700;
  color: #fff;
  white-space: nowrap;
  flex-shrink: 0;
`;

export const ComparisonSlot = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  background: ${({ $filled }) => ($filled ? "#FFFFFF" : "rgba(255, 255, 255, 0.15)")};
  border: 1.5px solid ${({ $filled }) => ($filled ? "#FFFFFF" : "rgba(255, 255, 255, 0.25)")};
  border-radius: 7px;
  padding: 6px 10px;
  height: 36px;
`;

export const ComparisonSlotText = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: ${({ $empty, $filled }) => ($empty ? "rgba(255,255,255,0.45)" : $filled ? "#000000" : "#fff")};
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ComparisonSlotClear = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: ${({ $filled }) => ($filled ? "rgba(0,0,0,0.45)" : "rgba(255, 255, 255, 0.65)")};
  display: flex;
  align-items: center;
  padding: 0;
  flex-shrink: 0;
  line-height: 1;
  transition: color 0.15s;

  &:hover {
    color: ${({ $filled }) => ($filled ? "#000000" : "#fff")};
  }
`;

export const ComparisonIconSep = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  opacity: 0.8;
`;

export const CancelCompareBtn = styled.button`
  background: transparent;
  border: 1.5px solid rgba(255, 255, 255, 0.55);
  border-radius: 7px;
  padding: 0 14px;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  height: 36px;
  transition: background 0.15s;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
`;

export const DoCompareBtn = styled.button`
  background: #fff;
  border: none;
  border-radius: 7px;
  padding: 0 14px;
  color: ${Colors.primaryPurple};
  font-size: 13px;
  font-weight: 700;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
  flex-shrink: 0;
  height: 36px;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  transition: opacity 0.15s;

  &:hover:not(:disabled) {
    opacity: 0.88;
  }
`;

/* ── Card comparison checkbox ── */
export const CardCompareCheckbox = styled.div`
  width: 22px;
  height: 22px;
  border-radius: 5px;
  border: 2px solid ${({ $checked }) => ($checked ? Colors.primaryPurple : Colors.ultraLightGray)};
  background: ${({ $checked }) => ($checked ? Colors.primaryPurple : "#fff")};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "pointer")};
  flex-shrink: 0;
  opacity: ${({ $disabled }) => ($disabled ? 0.3 : 1)};
  transition: border-color 0.15s, background 0.15s, opacity 0.15s;

  &:hover {
    border-color: ${({ $checked, $disabled }) =>
      !$disabled && !$checked ? Colors.primaryPurple : undefined};
  }
`;

export const CardCompareCheckMark = styled.div`
  width: 10px;
  height: 6px;
  border-left: 2px solid #fff;
  border-bottom: 2px solid #fff;
  transform: rotate(-45deg) translateY(-1px);
`;
